export enum JobDetailsTab {
  LOG_LIST = 'logs',
  MATERIAL_LIST = 'materials',
}
